export enum EstadoCambio {
    Nuevo, 
    Modifico, 
    NoHayCambios
}